import React, { useEffect, useState } from "react";
import { fetch_banners, delete_banners } from "../../../services/admin/banners";
import ItemListingTable, {
  getTableUpdateCallback,
} from "../common/ItemListingTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import ShopPopup from "./ShopPopup";
import { notify_promise } from "../../../services/utils/toasts";
import ListingPageControls from "../common/ListingPageControls";

const HomeBannersListingPage = ({ pageState, setPageState }) => {
  const [banners, setBanners] = useState([]);

  const [selectedBanner, setSelectedBanner] = useState(undefined);

  const [fields, setFields] = useState([]);
  const [pagination, setPagination] = useState({});

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search"));
  const [latestSearchQuery, setLatestSearchQuery] = useState(
    searchParams.get("search")
  );

  const [perPage, setPerPage] = useState(10);

  const apiCall = [
    fetch_banners,
    { page: 0, search: search ? search : "", perPage: perPage },
  ];

  const handleDelete = (id) => {
    notify_promise(
      new Promise((resolve, reject) => {
        delete_banners([id])
          .then((res) => {
            setBanners((prevBanners) => {
              return prevBanners.filter((p) => {
                return p.id !== id;
              });
            });
            resolve(res);
          })
          .catch(reject);
      })
    );
  };

  useEffect(() => {
    updateTableInfo(1);
  }, [latestSearchQuery, perPage]);

  useEffect(() => {
    setSearch(searchParams.get("search"));
  }, [searchParams.get("search")]);

  useEffect(() => {
    setLatestSearchQuery(search);
  }, [search]);

  const updateTableInfo = getTableUpdateCallback({
    apiCall: apiCall,
    dataSetter: setBanners,
    paginationSetter: setPagination,
    fieldSetter: setFields,
    buttons: [
      {
        template: "edit",
        getRedirectURL: (id) => {
          return "/admin/home-banners/edit/:id";
        },
      },
      {
        template: "delete",
        onClick: (id) => {
          handleDelete(id);
        },
      },
    ],
  });

  return (
    <div className="page-content py-3 px-4 bg-lightgray">
      <ShopPopup shop={selectedBanner} />

      <ListingPageControls
        type="banners"
        resultType="banners"
        addOnly={true}
        setSearch={setSearchParams}
        noExport={true}
        addNewLink="/admin/home-banners/add"
      />

      <ItemListingTable
        fields={fields}
        data={banners}
        pagination={pagination}
        updateTableInfo={updateTableInfo}
        wide={true}
        setPerPage={setPerPage}
        perPage={perPage}
      />
    </div>
  );
};

export default HomeBannersListingPage;